<template>
    <span v-if="displayBagdes" class="style-badge-container" @click.prevent="onClick">
        <span v-if="styles != null" v-for="style in sortedStyles" :key="style.id" :class="['badge', 'style-badge']">
            <span class="name">{{style.name}}</span>
        </span>
    </span>
    <input v-else type="text" readonly :placeholder="placeholderValue? placeholderValue : 'Styles'" :value="styleString" :class="!styleString || styleString.length === 0 ? 'is-empty' : ''" @click.prevent="onClick"  style="width: 100%"/>
</template>

<script>
    export default {
        name: "StyleBadgeList",
        props: {
            styles: [Array, String],
            displayBagdes: { type: Boolean, default: false },
            placeholderValue: String
        },
        computed: {
            sortedStyles() {
                if (this.styles === null) return [];

                return this.styles && this.styles.sort(function (a, b) {
                    if (a.displayOrder === b.displayOrder) return 0;
                    if (a.displayOrder > b.displayOrder) return 1;
                    return -1;
                });

                //return sortedStyles;
            },
            styleString() {
                let artNames = this.sortedStyles && this.sortedStyles.map(x => x.name);
                return artNames && artNames.join(', ');
            }
        },
        methods: {
            onClick(event) { this.$emit("click", event); }
        }
    }
</script>

<style scoped>
    .style-badge-container {
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #d2d2d2;
        height: 30px;
        display: block;
    }

        .style-badge-container:hover {
            border-bottom: 1px solid #18B9E7;
            cursor: pointer;
        }

    .style-badge {
        background: #18B9E7;
        border-radius: 100px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        padding: 5px 10px;
        color: white;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin: 0 5px;
    }

        .style-badge.hidden {
            background: #d2d2d2;
        }

        .style-badge .name {
            width: 100%;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0 1em;
        }

    input[type=text] {
        text-overflow: ellipsis;
        cursor: pointer;
    }
</style>
